import { __styles, mergeClasses, shorthands } from '@griffel/react';
import { tokens, typographyStyles } from '@fluentui/react-theme';
export const inputClassNames = {
  root: 'fui-Input',
  input: 'fui-Input__input',
  contentBefore: 'fui-Input__contentBefore',
  contentAfter: 'fui-Input__contentAfter'
}; // TODO(sharing) use theme values once available

const contentSizes = {
  // TODO: This 400 style is not in the typography styles.
  // May need a design change
  400: {
    fontSize: tokens.fontSizeBase400,
    lineHeight: tokens.lineHeightBase400
  }
}; // TODO(sharing) should these be shared somewhere?

const fieldHeights = {
  small: '24px',
  medium: '32px',
  large: '40px'
};

const useRootStyles = /*#__PURE__*/__styles({
  "base": {
    "mc9l5x": "ftuwxu6",
    "Bt984gj": "f122n59",
    "Eh141a": "flvyvdh",
    "i8kkvl": "f14mj54c",
    "Belr9w4": "fiut8dr",
    "Bahqtrf": "fk6fouc",
    "Bbmb7ep": ["f1aa9q02", "f16jpd5f"],
    "Beyfa6y": ["f16jpd5f", "f1aa9q02"],
    "B7oj6ja": ["f1jar5jt", "fyu767a"],
    "Btl43ni": ["fyu767a", "f1jar5jt"],
    "qhf8xq": "f10pi13n",
    "B7ck84d": "f1ewtqcl"
  },
  "interactive": {
    "li1rpt": "f1gw3sf2",
    "Bsft5z2": "f13zj6fq",
    "E3zdtr": "f1mdlcz9",
    "Eqx8gd": ["f1a7op3", "f1cjjd47"],
    "By385i5": "f1gboi2j",
    "B1piin3": ["f1cjjd47", "f1a7op3"],
    "Dlnsje": "f145g4dw",
    "d9w3h3": ["f1kp91vd", "f1ibwz09"],
    "B3778ie": ["f1ibwz09", "f1kp91vd"],
    "Bcgy8vk": "f1cb6c3",
    "Bw17bha": "f1lh990p",
    "B1q35kw": "f1jc6hxc",
    "Gjdm7m": "f13evtba",
    "b1kco5": "f1yk9hq",
    "Ba2ppi3": "fhwpy7i",
    "F2fol1": "f14ee0xe",
    "lck23g": "f1xhbsuh",
    "df92cz": "fv8e3ye",
    "I188md": "ftb5wc6",
    "umuwi5": "fjw5xc1",
    "Blcqepd": "f1xdyd5c",
    "nplu4u": "fatpbeo",
    "Bioka5o": "fb7uyps",
    "H713fs": "f1cmft4k",
    "B9ooomg": "f1x58t8o",
    "Bercvud": "f1ibeo51",
    "Bbr2w1p": "f14a1fxs",
    "Bduesf4": "f3e99gv",
    "Bpq79vn": "fhljsf7"
  },
  "small": {
    "sshi5w": "f1pha7fy",
    "z8tnut": "f1g0x7ka",
    "z189sj": ["fdw0yi8", "fk8j09s"],
    "Byoj8tv": "f1qch9an",
    "uwmqm3": ["fk8j09s", "fdw0yi8"],
    "Bahqtrf": "fk6fouc",
    "Be2twd7": "fy9rknc",
    "Bhrd7zp": "figsok6",
    "Bg96gwp": "fwrc4pm"
  },
  "medium": {
    "sshi5w": "f1nxs5xn",
    "z8tnut": "f1g0x7ka",
    "z189sj": ["f11gcy0p", "f1ng84yb"],
    "Byoj8tv": "f1qch9an",
    "uwmqm3": ["f1ng84yb", "f11gcy0p"],
    "Bahqtrf": "fk6fouc",
    "Be2twd7": "fkhj508",
    "Bhrd7zp": "figsok6",
    "Bg96gwp": "f1i3iumi"
  },
  "large": {
    "sshi5w": "f1w5jphr",
    "z8tnut": "f1g0x7ka",
    "z189sj": ["fw5db7e", "f1uw59to"],
    "Byoj8tv": "f1qch9an",
    "uwmqm3": ["f1uw59to", "fw5db7e"],
    "Be2twd7": "fod5ikn",
    "Bg96gwp": "faaz57k",
    "i8kkvl": "f1rjii52",
    "Belr9w4": "f1r7g2jn"
  },
  "outline": {
    "De3pzq": "fxugw4r",
    "B4j52fo": "f5ogflp",
    "Bekrc4i": ["f1hqa2wf", "finvdd3"],
    "Bn0qgzm": "f1f09k3d",
    "ibv6hh": ["finvdd3", "f1hqa2wf"],
    "icvyot": "fzkkow9",
    "vrafjx": ["fcdblym", "fjik90z"],
    "oivjwe": "fg706s2",
    "wvpqe5": ["fjik90z", "fcdblym"],
    "g2u3we": "fj3muxo",
    "h3c5rm": ["f1akhkt", "f1lxtadh"],
    "B9xav0g": "f1c1zstj",
    "zhjwy3": ["f1lxtadh", "f1akhkt"]
  },
  "outlineInteractive": {
    "Bgoe8wy": "fvcxoqz",
    "Bwzppfd": ["f1ub3y4t", "f1m52nbi"],
    "oetu4i": "f1l4zc64",
    "gg5e9n": ["f1m52nbi", "f1ub3y4t"],
    "Drbcw7": "f8vnjqi",
    "udz0bu": ["fz1etlk", "f1hc16gm"],
    "Be8ivqh": "f1klwx88",
    "ofdepl": ["f1hc16gm", "fz1etlk"]
  },
  "underline": {
    "De3pzq": "f1c21dwh",
    "Bbmb7ep": ["f1krrbdw", "f1deotkl"],
    "Beyfa6y": ["f1deotkl", "f1krrbdw"],
    "B7oj6ja": ["f10ostut", "f1ozlkrg"],
    "Btl43ni": ["f1ozlkrg", "f10ostut"],
    "Bn0qgzm": "f1f09k3d",
    "oivjwe": "fg706s2",
    "B9xav0g": "f1c1zstj"
  },
  "underlineInteractive": {
    "oetu4i": "f1l4zc64",
    "Be8ivqh": "f1klwx88",
    "B3778ie": ["f1nf3wye", "feulmo5"],
    "d9w3h3": ["feulmo5", "f1nf3wye"],
    "Bl18szs": ["f18vqdqu", "f53nyzz"],
    "B4j8arr": ["f53nyzz", "f18vqdqu"]
  },
  "filled": {
    "B4j52fo": "f5ogflp",
    "Bekrc4i": ["f1hqa2wf", "finvdd3"],
    "Bn0qgzm": "f1f09k3d",
    "ibv6hh": ["finvdd3", "f1hqa2wf"],
    "icvyot": "fzkkow9",
    "vrafjx": ["fcdblym", "fjik90z"],
    "oivjwe": "fg706s2",
    "wvpqe5": ["fjik90z", "fcdblym"],
    "g2u3we": "fghlq4f",
    "h3c5rm": ["f1gn591s", "fjscplz"],
    "B9xav0g": "fb073pr",
    "zhjwy3": ["fjscplz", "f1gn591s"]
  },
  "filledInteractive": {
    "q7v0qe": "ftmjh5b",
    "kmh5ft": ["f17blpuu", "fsrcdbj"],
    "nagaa4": "f1tpwn32",
    "B1yhkcb": ["fsrcdbj", "f17blpuu"]
  },
  "invalid": {
    "tvckwq": "fs4k3qj",
    "gk2u95": ["fcee079", "fmyw78r"],
    "hhx65j": "f1fgmyf4",
    "Bxowmz0": ["fmyw78r", "fcee079"]
  },
  "filled-darker": {
    "De3pzq": "f16xq7d1"
  },
  "filled-lighter": {
    "De3pzq": "fxugw4r"
  },
  "filled-darker-shadow": {
    "De3pzq": "f16xq7d1",
    "E5pizo": "fyed02w"
  },
  "filled-lighter-shadow": {
    "De3pzq": "fxugw4r",
    "E5pizo": "fyed02w"
  },
  "disabled": {
    "Bceei9c": "fdrzuqr",
    "De3pzq": "f1c21dwh",
    "g2u3we": "f1jj8ep1",
    "h3c5rm": ["f15xbau", "fy0fskl"],
    "B9xav0g": "f4ikngz",
    "zhjwy3": ["fy0fskl", "f15xbau"],
    "Bjwas2f": "fg455y9",
    "Bn1d65q": ["f1rvyvqg", "f14g86mu"],
    "Bxeuatn": "f1cwzwz",
    "n51gp8": ["f14g86mu", "f1rvyvqg"]
  }
}, {
  "d": [".ftuwxu6{display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;}", ".f122n59{-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}", ".flvyvdh{-webkit-box-flex-wrap:nowrap;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;}", ".f14mj54c{-webkit-column-gap:var(--spacingHorizontalXXS);column-gap:var(--spacingHorizontalXXS);}", ".fiut8dr{row-gap:var(--spacingHorizontalXXS);}", ".fk6fouc{font-family:var(--fontFamilyBase);}", ".f1aa9q02{border-bottom-right-radius:var(--borderRadiusMedium);}", ".f16jpd5f{border-bottom-left-radius:var(--borderRadiusMedium);}", ".f1jar5jt{border-top-right-radius:var(--borderRadiusMedium);}", ".fyu767a{border-top-left-radius:var(--borderRadiusMedium);}", ".f10pi13n{position:relative;}", ".f1ewtqcl{box-sizing:border-box;}", ".f1gw3sf2::after{box-sizing:border-box;}", ".f13zj6fq::after{content:\"\";}", ".f1mdlcz9::after{position:absolute;}", ".f1a7op3::after{left:-1px;}", ".f1cjjd47::after{right:-1px;}", ".f1gboi2j::after{bottom:-1px;}", ".f145g4dw::after{height:max(2px, var(--borderRadiusMedium));}", ".f1kp91vd::after{border-bottom-left-radius:var(--borderRadiusMedium);}", ".f1ibwz09::after{border-bottom-right-radius:var(--borderRadiusMedium);}", ".f1cb6c3::after{border-bottom-width:2px;}", ".f1lh990p::after{border-bottom-style:solid;}", ".f1jc6hxc::after{border-bottom-color:var(--colorCompoundBrandStroke);}", ".f13evtba::after{-webkit-clip-path:inset(calc(100% - 2px) 0 0 0);clip-path:inset(calc(100% - 2px) 0 0 0);}", ".f1yk9hq::after{-webkit-transform:scaleX(0);-moz-transform:scaleX(0);-ms-transform:scaleX(0);transform:scaleX(0);}", ".fhwpy7i::after{transition-property:transform;}", ".f14ee0xe::after{transition-duration:var(--durationUltraFast);}", ".f1xhbsuh::after{transition-delay:var(--curveAccelerateMid);}", ".f1pha7fy{min-height:24px;}", ".f1g0x7ka{padding-top:0;}", ".fdw0yi8{padding-right:var(--spacingHorizontalSNudge);}", ".fk8j09s{padding-left:var(--spacingHorizontalSNudge);}", ".f1qch9an{padding-bottom:0;}", ".fy9rknc{font-size:var(--fontSizeBase200);}", ".figsok6{font-weight:var(--fontWeightRegular);}", ".fwrc4pm{line-height:var(--lineHeightBase200);}", ".f1nxs5xn{min-height:32px;}", ".f11gcy0p{padding-right:var(--spacingHorizontalMNudge);}", ".f1ng84yb{padding-left:var(--spacingHorizontalMNudge);}", ".fkhj508{font-size:var(--fontSizeBase300);}", ".f1i3iumi{line-height:var(--lineHeightBase300);}", ".f1w5jphr{min-height:40px;}", ".fw5db7e{padding-right:var(--spacingHorizontalM);}", ".f1uw59to{padding-left:var(--spacingHorizontalM);}", ".fod5ikn{font-size:var(--fontSizeBase400);}", ".faaz57k{line-height:var(--lineHeightBase400);}", ".f1rjii52{-webkit-column-gap:var(--spacingHorizontalSNudge);column-gap:var(--spacingHorizontalSNudge);}", ".f1r7g2jn{row-gap:var(--spacingHorizontalSNudge);}", ".fxugw4r{background-color:var(--colorNeutralBackground1);}", ".f5ogflp{border-top-width:1px;}", ".f1hqa2wf{border-right-width:1px;}", ".finvdd3{border-left-width:1px;}", ".f1f09k3d{border-bottom-width:1px;}", ".fzkkow9{border-top-style:solid;}", ".fcdblym{border-right-style:solid;}", ".fjik90z{border-left-style:solid;}", ".fg706s2{border-bottom-style:solid;}", ".fj3muxo{border-top-color:var(--colorNeutralStroke1);}", ".f1akhkt{border-right-color:var(--colorNeutralStroke1);}", ".f1lxtadh{border-left-color:var(--colorNeutralStroke1);}", ".f1c1zstj{border-bottom-color:var(--colorNeutralStrokeAccessible);}", ".f1c21dwh{background-color:var(--colorTransparentBackground);}", ".f1krrbdw{border-bottom-right-radius:0;}", ".f1deotkl{border-bottom-left-radius:0;}", ".f10ostut{border-top-right-radius:0;}", ".f1ozlkrg{border-top-left-radius:0;}", ".f1nf3wye::after{border-bottom-right-radius:0;}", ".feulmo5::after{border-bottom-left-radius:0;}", ".f18vqdqu::after{border-top-right-radius:0;}", ".f53nyzz::after{border-top-left-radius:0;}", ".fghlq4f{border-top-color:var(--colorTransparentStroke);}", ".f1gn591s{border-right-color:var(--colorTransparentStroke);}", ".fjscplz{border-left-color:var(--colorTransparentStroke);}", ".fb073pr{border-bottom-color:var(--colorTransparentStroke);}", ".fs4k3qj:not(:focus-within),.fs4k3qj:hover:not(:focus-within){border-top-color:var(--colorPaletteRedBorder2);}", ".fcee079:not(:focus-within),.fcee079:hover:not(:focus-within){border-right-color:var(--colorPaletteRedBorder2);}", ".fmyw78r:not(:focus-within),.fmyw78r:hover:not(:focus-within){border-left-color:var(--colorPaletteRedBorder2);}", ".f1fgmyf4:not(:focus-within),.f1fgmyf4:hover:not(:focus-within){border-bottom-color:var(--colorPaletteRedBorder2);}", ".f16xq7d1{background-color:var(--colorNeutralBackground3);}", ".fyed02w{box-shadow:var(--shadow2);}", ".fdrzuqr{cursor:not-allowed;}", ".f1jj8ep1{border-top-color:var(--colorNeutralStrokeDisabled);}", ".f15xbau{border-right-color:var(--colorNeutralStrokeDisabled);}", ".fy0fskl{border-left-color:var(--colorNeutralStrokeDisabled);}", ".f4ikngz{border-bottom-color:var(--colorNeutralStrokeDisabled);}"],
  "m": [["@media screen and (prefers-reduced-motion: reduce){.fv8e3ye::after{transition-duration:0.01ms;}}", {
    "m": "screen and (prefers-reduced-motion: reduce)"
  }], ["@media screen and (prefers-reduced-motion: reduce){.ftb5wc6::after{transition-delay:0.01ms;}}", {
    "m": "screen and (prefers-reduced-motion: reduce)"
  }], ["@media screen and (prefers-reduced-motion: reduce){.f1cmft4k:focus-within::after{transition-duration:0.01ms;}}", {
    "m": "screen and (prefers-reduced-motion: reduce)"
  }], ["@media screen and (prefers-reduced-motion: reduce){.f1x58t8o:focus-within::after{transition-delay:0.01ms;}}", {
    "m": "screen and (prefers-reduced-motion: reduce)"
  }], ["@media (forced-colors: active){.fg455y9{border-top-color:GrayText;}}", {
    "m": "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1rvyvqg{border-right-color:GrayText;}.f14g86mu{border-left-color:GrayText;}}", {
    "m": "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1cwzwz{border-bottom-color:GrayText;}}", {
    "m": "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f14g86mu{border-left-color:GrayText;}.f1rvyvqg{border-right-color:GrayText;}}", {
    "m": "(forced-colors: active)"
  }]],
  "w": [".fjw5xc1:focus-within::after{-webkit-transform:scaleX(1);-moz-transform:scaleX(1);-ms-transform:scaleX(1);transform:scaleX(1);}", ".f1xdyd5c:focus-within::after{transition-property:transform;}", ".fatpbeo:focus-within::after{transition-duration:var(--durationNormal);}", ".fb7uyps:focus-within::after{transition-delay:var(--curveDecelerateMid);}", ".f1ibeo51:focus-within:active::after{border-bottom-color:var(--colorCompoundBrandStrokePressed);}", ".f14a1fxs:focus-within{outline-width:2px;}", ".f3e99gv:focus-within{outline-style:solid;}", ".fhljsf7:focus-within{outline-color:transparent;}"],
  "h": [".fvcxoqz:hover{border-top-color:var(--colorNeutralStroke1Hover);}", ".f1ub3y4t:hover{border-right-color:var(--colorNeutralStroke1Hover);}", ".f1m52nbi:hover{border-left-color:var(--colorNeutralStroke1Hover);}", ".f1l4zc64:hover{border-bottom-color:var(--colorNeutralStrokeAccessibleHover);}", ".ftmjh5b:hover,.ftmjh5b:focus-within{border-top-color:var(--colorTransparentStrokeInteractive);}", ".f17blpuu:hover,.f17blpuu:focus-within{border-right-color:var(--colorTransparentStrokeInteractive);}", ".fsrcdbj:hover,.fsrcdbj:focus-within{border-left-color:var(--colorTransparentStrokeInteractive);}", ".f1tpwn32:hover,.f1tpwn32:focus-within{border-bottom-color:var(--colorTransparentStrokeInteractive);}"],
  "a": [".f8vnjqi:active,.f8vnjqi:focus-within{border-top-color:var(--colorNeutralStroke1Pressed);}", ".fz1etlk:active,.fz1etlk:focus-within{border-right-color:var(--colorNeutralStroke1Pressed);}", ".f1hc16gm:active,.f1hc16gm:focus-within{border-left-color:var(--colorNeutralStroke1Pressed);}", ".f1klwx88:active,.f1klwx88:focus-within{border-bottom-color:var(--colorNeutralStrokeAccessiblePressed);}"]
});

const useInputElementStyles = /*#__PURE__*/__styles({
  "base": {
    "B7ck84d": "f1ewtqcl",
    "Bh6795r": "fqerorx",
    "Bf4jedk": "fy77jfu",
    "icvyot": "f1ern45e",
    "vrafjx": ["f1n71otn", "f1deefiw"],
    "oivjwe": "f1h8hb77",
    "wvpqe5": ["f1deefiw", "f1n71otn"],
    "z8tnut": "f1g0x7ka",
    "z189sj": ["ffczdla", "fgiv446"],
    "Byoj8tv": "f1qch9an",
    "uwmqm3": ["fgiv446", "ffczdla"],
    "sj55zd": "f19n0e5",
    "De3pzq": "f3rmtva",
    "yvdlaj": "fwyc1cq",
    "B3o7kgh": "f13ta7ih",
    "oeaueh": "f1s6fcnf"
  },
  "small": {
    "Bahqtrf": "fk6fouc",
    "Be2twd7": "fy9rknc",
    "Bhrd7zp": "figsok6",
    "Bg96gwp": "fwrc4pm"
  },
  "medium": {
    "Bahqtrf": "fk6fouc",
    "Be2twd7": "fkhj508",
    "Bhrd7zp": "figsok6",
    "Bg96gwp": "f1i3iumi"
  },
  "large": {
    "Be2twd7": "fod5ikn",
    "Bg96gwp": "faaz57k",
    "z8tnut": "f1g0x7ka",
    "z189sj": ["fdw0yi8", "fk8j09s"],
    "Byoj8tv": "f1qch9an",
    "uwmqm3": ["fk8j09s", "fdw0yi8"]
  },
  "disabled": {
    "sj55zd": "f1s2aq7o",
    "De3pzq": "f1c21dwh",
    "Bceei9c": "fdrzuqr",
    "yvdlaj": "fahhnxm"
  }
}, {
  "d": [".f1ewtqcl{box-sizing:border-box;}", ".fqerorx{-webkit-box-flex:1;-webkit-flex-grow:1;-ms-flex-positive:1;flex-grow:1;}", ".fy77jfu{min-width:0;}", ".f1ern45e{border-top-style:none;}", ".f1n71otn{border-right-style:none;}", ".f1deefiw{border-left-style:none;}", ".f1h8hb77{border-bottom-style:none;}", ".f1g0x7ka{padding-top:0;}", ".ffczdla{padding-right:var(--spacingHorizontalXXS);}", ".fgiv446{padding-left:var(--spacingHorizontalXXS);}", ".f1qch9an{padding-bottom:0;}", ".f19n0e5{color:var(--colorNeutralForeground1);}", ".f3rmtva{background-color:transparent;}", ".fwyc1cq::-webkit-input-placeholder{color:var(--colorNeutralForeground4);}", ".fwyc1cq::-moz-placeholder{color:var(--colorNeutralForeground4);}", ".f13ta7ih::-webkit-input-placeholder{opacity:1;}", ".f13ta7ih::-moz-placeholder{opacity:1;}", ".f1s6fcnf{outline-style:none;}", ".fk6fouc{font-family:var(--fontFamilyBase);}", ".fy9rknc{font-size:var(--fontSizeBase200);}", ".figsok6{font-weight:var(--fontWeightRegular);}", ".fwrc4pm{line-height:var(--lineHeightBase200);}", ".fkhj508{font-size:var(--fontSizeBase300);}", ".f1i3iumi{line-height:var(--lineHeightBase300);}", ".fod5ikn{font-size:var(--fontSizeBase400);}", ".faaz57k{line-height:var(--lineHeightBase400);}", ".fdw0yi8{padding-right:var(--spacingHorizontalSNudge);}", ".fk8j09s{padding-left:var(--spacingHorizontalSNudge);}", ".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}", ".f1c21dwh{background-color:var(--colorTransparentBackground);}", ".fdrzuqr{cursor:not-allowed;}", ".fahhnxm::-webkit-input-placeholder{color:var(--colorNeutralForegroundDisabled);}", ".fahhnxm::-moz-placeholder{color:var(--colorNeutralForegroundDisabled);}"]
});

const useContentStyles = /*#__PURE__*/__styles({
  "base": {
    "B7ck84d": "f1ewtqcl",
    "sj55zd": "f11d4kpn",
    "clhimo": "fyuhxbn"
  },
  "disabled": {
    "sj55zd": "f1s2aq7o"
  },
  "small": {
    "kwki1k": "f3u2cy0"
  },
  "medium": {
    "kwki1k": "f1oqplr0"
  },
  "large": {
    "kwki1k": "fa420co"
  }
}, {
  "d": [".f1ewtqcl{box-sizing:border-box;}", ".f11d4kpn{color:var(--colorNeutralForeground3);}", ".fyuhxbn>svg{display:block;}", ".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}", ".f3u2cy0>svg{font-size:16px;}", ".f1oqplr0>svg{font-size:20px;}", ".fa420co>svg{font-size:24px;}"]
});
/**
 * Apply styling to the Input slots based on the state
 */


export const useInputStyles_unstable = state => {
  const {
    size,
    appearance
  } = state;
  const disabled = state.input.disabled;
  const invalid = `${state.input['aria-invalid']}` === 'true';
  const filled = appearance.startsWith('filled');
  const rootStyles = useRootStyles();
  const inputStyles = useInputElementStyles();
  const contentStyles = useContentStyles();
  state.root.className = mergeClasses(inputClassNames.root, rootStyles.base, rootStyles[size], rootStyles[appearance], !disabled && rootStyles.interactive, !disabled && appearance === 'outline' && rootStyles.outlineInteractive, !disabled && appearance === 'underline' && rootStyles.underlineInteractive, !disabled && filled && rootStyles.filledInteractive, filled && rootStyles.filled, !disabled && invalid && rootStyles.invalid, disabled && rootStyles.disabled, state.root.className);
  state.input.className = mergeClasses(inputClassNames.input, inputStyles.base, inputStyles[size], disabled && inputStyles.disabled, state.input.className);
  const contentClasses = [contentStyles.base, disabled && contentStyles.disabled, contentStyles[size]];

  if (state.contentBefore) {
    state.contentBefore.className = mergeClasses(inputClassNames.contentBefore, ...contentClasses, state.contentBefore.className);
  }

  if (state.contentAfter) {
    state.contentAfter.className = mergeClasses(inputClassNames.contentAfter, ...contentClasses, state.contentAfter.className);
  }

  return state;
};
//# sourceMappingURL=useInputStyles.js.map